import { on as onEvent } from "common/utils/ui/event";

export default () => {
  const eventCallback = () => window.print();
  onEvent("click", ".js-print", eventCallback, true);
};
